import {useMemo} from 'react'

import {usePlantProductionLines} from './usePlantProductionLines'

export const usePlantProductionLineIds: () => string[] = () => {
  const productionLines = usePlantProductionLines()
  return useMemo(() => productionLines.map(({id}) => id), [productionLines])
}
